/* @flow */
import * as React from 'react';
import Text from 'components/Text';
import Time from 'components/Time';
import Row from 'components/Row';
import MediaObject from 'components/MediaObject';

import './styles/AdminUpgradeQuoteTotalBox.scss';

type Props = {
  quote: {
    total: string,
    expirationDate: string,
  },
};

export default class AdminUpgradeQuoteTotalBox extends React.Component<Props> {
  render() {
    const { quote } = this.props;
    return (
      <div className="AdminUpgradeQuoteTotalBox">
        <Row size="xsmall">
          <MediaObject figure="right">
            <Text element="div" size="medium" weight="semibold">
              Order total
            </Text>
            <Text element="div" size="medium" weight="semibold">
              {quote.total}
            </Text>
          </MediaObject>
        </Row>
        <Text element="div" color="thunder">
          Quote valid through{' '}
          <Time date={new Date(quote.expirationDate)} month="long" day="numeric" year="numeric" />
        </Text>
      </div>
    );
  }
}
